import Navbar from "./Components/Navbar&Hero/Navbar";
import HeroSection from "./Components/Navbar&Hero/HeroSection";
import Services from "./Components/Services/Services";
import About from "./Components/About/About";

import NewSkills from "./Components/NewSkills/NewSkills";


import Contact from "./Components/Contact/Contact";

import Projects from "./Components/Projects/Projects";
import Testiomonial from "./Components/Testimonial/Testiomonial";
import Footer from "./Components/Footer/Footer";

// import Brands from "./Components/Brands/Brands";



function App() {
  return (
   <>
   
    
  <Navbar/>
  <HeroSection/>
 
  <Services/>
  <About/>
  <Projects/>
       <NewSkills/>
  
       

    
   

  
   <Testiomonial/>
   <Contact/>


   <Footer/>

   {/* <Brands/> */}
   </>
  );
}

export default App;
